var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["bet-zone-info", { reverse: _vm.isReverse }] }, [
    _c("div", { staticClass: "banker-info" }, [
      _c("div", { staticClass: "total-bet" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "RadialProgressBar",
              {
                attrs: {
                  diameter: 40,
                  strokeWidth: 3,
                  innerStrokeWidth: 3,
                  startColor: "#ffbfbf",
                  stopColor: "#ffbfbf",
                  innerStrokeColor: "#043417",
                  animateSpeed: 1000,
                  "completed-steps": _vm.bankerRatio,
                  "total-steps": 100,
                  isClockwise: true,
                },
              },
              [_vm._v(" " + _vm._s(_vm.bankerRatio) + "% ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            {
              staticClass: "total-bet-amount",
              class: { "large-amount": _vm.isLargeAmount },
            },
            [
              _vm._v(
                _vm._s(_vm.currencySymbol) +
                  " " +
                  _vm._s(
                    _vm.isLargeAmount
                      ? _vm.fla(
                          _vm.valueAfterExchange(_vm.banker.totalBetAmount)
                        )
                      : _vm.fa(
                          _vm.valueAfterExchange(_vm.banker.totalBetAmount)
                        )
                  )
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "total-bet-count" },
            [
              _c("PersonIcon"),
              _c("span", [_vm._v(_vm._s(_vm.banker.totalBetCount))]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "odds" }, [
        _vm._v(_vm._s(_vm.banker.odds) + "x"),
      ]),
      _c("div", { staticClass: "owner-bet" }, [
        _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.$t("Banker")))]),
        _c("div", { staticClass: "confirmed-bet" }, [
          _vm._v(
            _vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.fa(_vm.myBets.banker))
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "draw-info" }, [
      _c("div", { staticClass: "odds" }, [
        _c("div", { staticClass: "draw-odds-label" }, [
          _vm._v(_vm._s(_vm.$t("Draw"))),
        ]),
        _c("div", [_vm._v(_vm._s(_vm.draw.odds) + "x")]),
      ]),
      _c("div", { staticClass: "confirmed-bet" }, [
        _vm._v(
          _vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.fa(_vm.myBets.draw))
        ),
      ]),
    ]),
    _c("div", { staticClass: "player-info" }, [
      _c("div", { staticClass: "total-bet" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "RadialProgressBar",
              {
                attrs: {
                  diameter: 40,
                  strokeWidth: 3,
                  innerStrokeWidth: 3,
                  startColor: "#93c4ff",
                  stopColor: "#93c4ff",
                  innerStrokeColor: "#043417",
                  animateSpeed: 1000,
                  "completed-steps": _vm.playerRatio,
                  "total-steps": 100,
                  isClockwise: true,
                },
              },
              [_vm._v(" " + _vm._s(_vm.playerRatio) + "% ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            {
              staticClass: "total-bet-amount",
              class: { "large-amount": _vm.isLargeAmount },
            },
            [
              _vm._v(
                _vm._s(_vm.currencySymbol) +
                  " " +
                  _vm._s(
                    _vm.isLargeAmount
                      ? _vm.fla(
                          _vm.valueAfterExchange(_vm.player.totalBetAmount)
                        )
                      : _vm.fa(
                          _vm.valueAfterExchange(_vm.player.totalBetAmount)
                        )
                  )
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "total-bet-count" },
            [
              _c("PersonIcon", { attrs: { role: "player" } }),
              _c("span", [_vm._v(_vm._s(_vm.player.totalBetCount))]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "odds" }, [
        _vm._v(_vm._s(_vm.player.odds) + "x"),
      ]),
      _c("div", { staticClass: "owner-bet" }, [
        _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.$t("Player")))]),
        _c("div", { staticClass: "confirmed-bet" }, [
          _vm._v(
            _vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.fa(_vm.myBets.player))
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }